/**
 * An absolute URL for a Pinksy API path.
 *
 * A relative base (`/api/pinksy`) resolves against the page's own origin — jose's remote key set and
 * `fetch` both want something absolute. Same-origin by default (D29, hardrules §5: never a host,
 * never a localhost API base), so the bundle carries no host and needs no CORS however it was built.
 *
 * This replaced `passportApi.ts` when the Passport app was deleted (PNK-106). There was a second
 * base then — `/api/passport`, a whole other Encore app — and every caller had to choose. There is
 * one app now, so the choice is gone and so is the class of bug it carried: a request sent to the
 * app that did not issue the session came back 401, which everything downstream reads as "your
 * session ended".
 */
import { API_BASE_URL } from "@/api/base";

export function apiUrl(path: string, base: string = API_BASE_URL, origin: string = window.location.origin): URL {
  const root = base.startsWith("/") ? `${origin}${base}` : base;
  return new URL(`${root}/${path.replace(/^\/+/, "")}`);
}
